import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  LinearProgress,
  Snackbar,
  Alert,
  Slide,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Divider,
  InputLabel,
  Select,
  MenuItem,
  Switch,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';

import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  textAlign: 'center',
  backgroundColor: '#47A992',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const AQLParameterInitialValue = {
  Level: '1',
  MinAuditPcs: '',
  MaxAuditPcs: '',
  SampleQty: '',
  MajorAQL065: '0',
  MajorAQL10: '0',
  MajorAQL15: '0',
  MajorAQL25: '0',
  MajorAQL40: '0',
  MajorAQL65: '0',
  MinorAQL065: '0',
  MinorAQL10: '0',
  MinorAQL15: '0',
  MinorAQL25: '0',
  MinorAQL40: '0',
  MinorAQL65: '0',
  Active: 'yes',
};

const LevelOptions = [1, 2, 3];

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const AQLParameter = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [aqlParameterTableData, setAQLParameterTableData] = useState([]);
  const [aqlParameters, setAQLParameters] = useState([]);
  const [defectCategory, setDefectCategory] = useState([]);
  const [UserId, setUserId] = useState(null);

  const [initialValue, setInitialValue] = useState(AQLParameterInitialValue);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    getAllAQLParameter();
    GetAllHelpData();
  }, []);

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const resData = await axios.get('Master/DefectCategory/GetAllActiveDefectCategory');
      setDefectCategory(resData.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const aqlParameterValidationSchema = useMemo(
    () =>
      Yup.object()
        .shape({
          Level: Yup.number().required('Please select Level'),
          MinAuditPcs: Yup.number()
            .integer('Must be an Integer , decimals are not allowed')
            .min(0, 'Must be at least 1')
            .required('Enter Minimum Audit Pcs'),
          MaxAuditPcs: Yup.number()
            .integer('Must be an Integer , decimals are not allowed')
            .min(1, 'Must be at least 0')
            .required('Enter Maximum Audit Pcs'),
          SampleQty: Yup.number()
            .integer('Must be an Integer , decimals are not allowed')
            .min(1, 'Must be at least 1')
            .required('Enter Sample Quantity'),
          MajorAQL065: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MajorAQL10: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MajorAQL15: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MajorAQL25: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MajorAQL40: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MajorAQL65: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MinorAQL065: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MinorAQL10: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MinorAQL15: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MinorAQL25: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MinorAQL40: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          MinorAQL65: Yup.number()
            .typeError('Must be a number')
            .min(0, 'Must be at least 0')
            .max(100, 'Must be at most 100')
            .required('Enter Value'),
          Active: Yup.string().oneOf(['yes', 'No'], 'Please select Yes or No').required('Please select Yes or No'),
        })
        .test('min-max-check', 'Minimum Audit Pcs must be less than Maximum Audit Pcs', (values, context) => {
          // ⬅️ Ensure this is an arrow function
          const { MinAuditPcs, MaxAuditPcs } = values;
          if (MinAuditPcs >= MaxAuditPcs) {
            return context.createError({
              message: 'Max Audit Pcs must be less greater than Min Audit Pcs',
              path: 'MaxAuditPcs', // You can change this to the field you want to show the error on
            });
          }
          return true;
        }),
    []
  );

  async function getAllAQLParameter() {
    try {
      showLoading();
      const response = await axios.get('Master/AQLParameter/GetAllAQLParameter');
      setAQLParameters(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function InsertAQLParameter(values) {
    try {
      showLoading();
      const response = await axios.post('Master/AQLParameter/AddAQLParameter', { ...values, UserId });
      getAllAQLParameter();
      openSnackBar('AQL Parameter Added Successfully!');
      // setFilterData(filterInitialValue);
      setEdit(false);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
    setOpen(false);
  }

  const UpdateAQLParameter = async (values) => {
    try {
      showLoading();
      await axios.post(`Master/AQLParameter/UpdateAQLParameter`, {
        ...values,
        UserId,
      });
      getAllAQLParameter();
      setInitialValue(AQLParameterInitialValue);
      openSnackBar('AQL Parameter Updated Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    setOpen(false);
    setEdit(false);
    hideLoading();
  };

  const DeleteAQLParameter = async () => {
    try {
      showLoading();
      await axios.delete(`Master/AQLParameter/DeleteAQLParameter/${deleteId}`);
      const newAQLParameter = aqlParameters.filter((aqlParameter) => aqlParameter.QAParameterId !== deleteId);
      setAQLParameters(newAQLParameter);
      setAQLParameterTableData(newAQLParameter);
      openSnackBar('AQL Parameter Deleted Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const handleEditClick = (values) => {
    setInitialValue(values);
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };
  useEffect(() => {
    const newTableData = aqlParameters.filter(
      (AQLParam) =>
        `${AQLParam.Level} ${AQLParam.MaxAuditPcs} ${AQLParam.MinAuditPcs} ${AQLParam.SampleQty}`
          .toLowerCase()
          .includes(filterData?.searchTerm?.toLowerCase())  &&
          AQLParam.Active?.toLowerCase()?.trim() === (filterData.Active ? 'yes' : 'no')
    );
    if (page > 0) setPage(0);
    setAQLParameterTableData(newTableData);
  }, [aqlParameters, filterData]);

  // function handleAQLParameterFilterSearch(filtertext) {
  //   setAQLParameterFilterSearch(filtertext);
  //   const newDivsionTableData = aqlParameters.filter((AQLParam) =>
  //     `${AQLParam.MaxAuditPcs} ${AQLParam.MinAuditPcs} ${AQLParam.SampleQty}`
  //       .toLowerCase()
  //       .includes(filtertext.toLowerCase())
  //   );
  //   if (page > 0) setPage(0);
  //   setAQLParameterTableData(newDivsionTableData);
  // }
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleCloseDialog = () => {
    setOpen(!open);
    setEdit(false);
    setInitialValue(AQLParameterInitialValue);
  };

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = aqlParameterTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [aqlParameterTableData, page, rowsPerPage]);

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              AQL PARAMETER MASTER
            </Typography>
          </Typography>
        </Grid>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          my={3}
          px={3}
        >
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => {
              handleFilterDataChange('searchTerm', e.target.value);
            }}
            value={filterData.searchTerm}
          />
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="subtitle2" fontWeight="bold">
              Active
            </Typography>

            {/* Toggle Switch with "Yes" / "No" */}
            <FormControlLabel
              control={
                <Switch
                  checked={filterData.Active}
                  onChange={(e) => {
                    handleFilterDataChange('Active', !filterData.Active);
                  }}
                  color="success"
                />
              }
              label={filterData.Active ? 'Yes' : 'No'}
            />
            <Divider orientation="vertical" flexItem />
            <Button
              variant="outlined"
              color="secondary"
              sx={{ boxShadow: 1 }}
              onClick={() => setOpen(!open)}
              startIcon={<PlaylistAddIcon />}
            >
              Add AQL Parameter
            </Button>
          </Stack>
        </Stack>
        <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
          <Table className="aqlparameter-table-bordered" size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" colSpan={2}>
                  {' '}
                </StyledTableCell>
                <StyledTableCell align="center" colSpan={2}>
                  Pieces Audit
                </StyledTableCell>
                <StyledTableCell align="center" colSpan={1}>
                  {' '}
                </StyledTableCell>
                <StyledTableCell align="center" className="text-center" colSpan={6}>
                  Major AQL
                </StyledTableCell>{' '}
                <StyledTableCell align="center" className="text-center" colSpan={6}>
                  Minor AQL
                </StyledTableCell>
                <StyledTableCell align="center" colSpan={2} className="text-center">
                  {' '}
                </StyledTableCell>
              </TableRow>

              <TableRow sx={{ padding: 'none' }}>
                <StyledTableCell>S.No</StyledTableCell>
                <StyledTableCell>Level</StyledTableCell>
                <StyledTableCell>Min</StyledTableCell>
                <StyledTableCell>Max</StyledTableCell>
                <StyledTableCell className="text-center">Sample Qty</StyledTableCell>

                <StyledTableCell className="text-center"> 0.65</StyledTableCell>
                <StyledTableCell className="text-center"> 1.0</StyledTableCell>
                <StyledTableCell className="text-center"> 1.5</StyledTableCell>
                <StyledTableCell className="text-center"> 2.5</StyledTableCell>
                <StyledTableCell className="text-center"> 4.0</StyledTableCell>
                <StyledTableCell className="text-center"> 6.5</StyledTableCell>

                <StyledTableCell className="text-center"> 0.65</StyledTableCell>
                <StyledTableCell className="text-center"> 1.0</StyledTableCell>
                <StyledTableCell className="text-center"> 1.5</StyledTableCell>
                <StyledTableCell className="text-center"> 2.5</StyledTableCell>
                <StyledTableCell className="text-center"> 4.0</StyledTableCell>
                <StyledTableCell className="text-center"> 6.5</StyledTableCell>
                <StyledTableCell className="text-center">Active</StyledTableCell>
                <StyledTableCell className="text-center">Action</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? aqlParameterTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : aqlParameterTableData
              ).map((aqlParameter, i) => (
                <TableRow key={aqlParameter.QAParameterId} hover>
                  
                  <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                  {/* <TableCell align="center">{aqlParameter.SNo}</TableCell> */}
                  <TableCell align="center">{aqlParameter.Level}</TableCell>
                  <TableCell align="center">{aqlParameter.MinAuditPcs}</TableCell>
                  <TableCell align="center">{aqlParameter.MaxAuditPcs}</TableCell>
                  <TableCell align="center">{aqlParameter.SampleQty}</TableCell>
                  <TableCell align="center">{aqlParameter.MajorAQL065}</TableCell>
                  <TableCell align="center">{aqlParameter.MajorAQL10}</TableCell>
                  <TableCell align="center">{aqlParameter.MajorAQL15}</TableCell>
                  <TableCell align="center">{aqlParameter.MajorAQL25}</TableCell>
                  <TableCell align="center">{aqlParameter.MajorAQL40}</TableCell>
                  <TableCell align="center">{aqlParameter.MinorAQL65}</TableCell>
                  <TableCell align="center">{aqlParameter.MinorAQL065}</TableCell>
                  <TableCell align="center">{aqlParameter.MinorAQL10}</TableCell>
                  <TableCell align="center">{aqlParameter.MinorAQL15}</TableCell>
                  <TableCell align="center">{aqlParameter.MinorAQL25}</TableCell>
                  <TableCell align="center">{aqlParameter.MinorAQL40}</TableCell>
                  <TableCell align="center">{aqlParameter.MinorAQL65}</TableCell>
                  <TableCell align="center">
                    <Chip
                      color={aqlParameter.Active === 'yes' ? 'success' : 'error'}
                      label={aqlParameter.Active === 'yes' ? 'Yes' : 'No'}
                      size="small"
                      variant="outlined"
                      icon={
                        aqlParameter.Active === 'yes' ? (
                          <CheckCircleOutlineIcon fontSize="small" />
                        ) : (
                          <HighlightOffIcon fontSize="small" />
                        )
                      }
                    />
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{ padding: '0', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <IconButton
                      aria-label="Edit"
                      onClick={() => {
                        setEdit(true);
                        setOpen(true);
                        handleEditClick(aqlParameter);
                      }}
                      size="small"
                    >
                      <EditIcon color="primary" fontSize="small" />
                    </IconButton>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        setDeleteId(aqlParameter.QAParameterId);
                        setOpenDelete(true);
                      }}
                      size="small"
                    >
                      <DeleteForeverIcon color="error" fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
        <Grid m={2}>
          {/* add new popup form dialog box */}
          <Dialog maxWidth={'lg'} open={open} onClose={handleCloseDialog} fullWidth>
            <Container component={Paper} elevation={2} style={{ padding: '7px 14px' }}>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h6" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {edit ? 'Edit' : 'Add'} AQL Parameter
                </Typography>
                <IconButton onClick={handleCloseDialog}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack sx={{ p: 1 }}>
                <Formik
                  validationSchema={aqlParameterValidationSchema}
                  initialValues={initialValue}
                  onSubmit={async (values, { resetForm }) => {
                    if (edit) await UpdateAQLParameter(values);
                    else await InsertAQLParameter(values);
                    resetForm();
                  }}
                >
                  {({ submitForm, values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                      <Grid container spacing={2} p={1} rowSpacing={3}>
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth size="small">
                            <InputLabel>Level</InputLabel>
                            <Select
                              value={values.Level || ''}
                              name="Level"
                              size="small"
                              label="Level"
                              onChange={handleChange}
                              error={touched.Level && !!errors.Level}
                              onBlur={handleBlur}
                            >
                              {LevelOptions.map((level, i) => (
                                <MenuItem key={level} value={level}>
                                  {level}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.Level && touched.Level && (
                              <Typography
                                variant="caption"
                                color="error"
                                className="shake-helper-text"
                                margin="4px 0 0 14px"
                              >
                                {errors.Level}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="Min Audit Pcs"
                            type="number"
                            name="MinAuditPcs"
                            onBlur={handleBlur}
                            error={!!errors.MinAuditPcs && touched.MinAuditPcs}
                            helperText={errors.MinAuditPcs && touched.MinAuditPcs ? errors.MinAuditPcs : ''}
                            value={values.MinAuditPcs}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="Max Audit Pcs"
                            type="number"
                            name="MaxAuditPcs"
                            onBlur={handleBlur}
                            error={!!errors.MaxAuditPcs && touched.MaxAuditPcs}
                            helperText={errors.MaxAuditPcs && touched.MaxAuditPcs ? errors.MaxAuditPcs : ''}
                            value={values.MaxAuditPcs}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="Sample Quantity"
                            type="number"
                            name="SampleQty"
                            onBlur={handleBlur}
                            error={!!errors.SampleQty && touched.SampleQty}
                            helperText={errors.SampleQty && touched.SampleQty ? errors.SampleQty : ''}
                            value={values.SampleQty}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <Divider variant="middle">
                            <Chip label="Major" size="small" color="info" variant="outlined" />
                          </Divider>
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="0.65"
                            type="number"
                            name="MajorAQL065"
                            onBlur={handleBlur}
                            error={!!errors.MajorAQL065 && touched.MajorAQL065}
                            helperText={errors.MajorAQL065 && touched.MajorAQL065 ? errors.MajorAQL065 : ''}
                            value={values.MajorAQL065}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="1.0"
                            type="number"
                            name="MajorAQL10"
                            onBlur={handleBlur}
                            error={!!errors.MajorAQL10 && touched.MajorAQL10}
                            helperText={errors.MajorAQL10 && touched.MajorAQL10 ? errors.MajorAQL10 : ''}
                            value={values.MajorAQL10}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="1.5"
                            type="number"
                            name="MajorAQL15"
                            onBlur={handleBlur}
                            error={!!errors.MajorAQL15 && touched.MajorAQL15}
                            helperText={errors.MajorAQL15 && touched.MajorAQL15 ? errors.MajorAQL15 : ''}
                            value={values.MajorAQL15}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="2.5"
                            type="number"
                            name="MajorAQL25"
                            onBlur={handleBlur}
                            error={!!errors.MajorAQL25 && touched.MajorAQL25}
                            helperText={errors.MajorAQL25 && touched.MajorAQL25 ? errors.MajorAQL25 : ''}
                            value={values.MajorAQL25}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="4.0"
                            type="number"
                            name="MajorAQL40"
                            onBlur={handleBlur}
                            error={!!errors.MajorAQL40 && touched.MajorAQL40}
                            helperText={errors.MajorAQL40 && touched.MajorAQL40 ? errors.MajorAQL40 : ''}
                            value={values.MajorAQL40}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="6.5"
                            type="number"
                            name="MajorAQL65"
                            onBlur={handleBlur}
                            error={!!errors.MajorAQL65 && touched.MajorAQL65}
                            helperText={errors.MajorAQL65 && touched.MajorAQL65 ? errors.MajorAQL65 : ''}
                            value={values.MajorAQL65}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <Divider variant="middle">
                            <Chip label="Minor" size="small" color="info" variant="outlined" />
                          </Divider>
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="0.65"
                            type="number"
                            name="MinorAQL065"
                            onBlur={handleBlur}
                            error={!!errors.MinorAQL065 && touched.MinorAQL065}
                            helperText={errors.MinorAQL065 && touched.MinorAQL065 ? errors.MinorAQL065 : ''}
                            value={values.MinorAQL065}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="1.0"
                            type="number"
                            name="MinorAQL10"
                            onBlur={handleBlur}
                            error={!!errors.MinorAQL10 && touched.MinorAQL10}
                            helperText={errors.MinorAQL10 && touched.MinorAQL10 ? errors.MinorAQL10 : ''}
                            value={values.MinorAQL10}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="1.5"
                            type="number"
                            name="MinorAQL15"
                            onBlur={handleBlur}
                            error={!!errors.MinorAQL15 && touched.MinorAQL15}
                            helperText={errors.MinorAQL15 && touched.MinorAQL15 ? errors.MinorAQL15 : ''}
                            value={values.MinorAQL15}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="2.5"
                            type="number"
                            name="MinorAQL25"
                            onBlur={handleBlur}
                            error={!!errors.MinorAQL25 && touched.MinorAQL25}
                            helperText={errors.MinorAQL25 && touched.MinorAQL25 ? errors.MinorAQL25 : ''}
                            value={values.MinorAQL25}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="4.0"
                            type="number"
                            name="MinorAQL40"
                            onBlur={handleBlur}
                            error={!!errors.MinorAQL40 && touched.MinorAQL40}
                            helperText={errors.MinorAQL40 && touched.MinorAQL40 ? errors.MinorAQL40 : ''}
                            value={values.MinorAQL40}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} md={2}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="6.5"
                            type="number"
                            name="MinorAQL65"
                            onBlur={handleBlur}
                            error={!!errors.MinorAQL65 && touched.MinorAQL65}
                            helperText={errors.MinorAQL65 && touched.MinorAQL65 ? errors.MinorAQL65 : ''}
                            value={values.MinorAQL65}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <FormControl size="small" fullWidth component="fieldset">
                            <FormLabel component="legend">Active Status</FormLabel>
                            <RadioGroup
                              row
                              value={values.Active?.trim()}
                              name="Active"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            >
                              <FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
                              <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                            </RadioGroup>
                            {errors.Active && touched.Active && (
                              <Typography
                                variant="caption"
                                color="error"
                                className={errors.Active ? 'shake-helper-text' : ''}
                              >
                                {errors.Active}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                        <Button
                          onClick={submitForm}
                          disabled={isSubmitting}
                          fullWidth
                          variant="contained"
                          color={edit ?  'warning':'primary' }
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          {edit ? 'Update' : 'Save'}
                        </Button>
                      </Stack>
                    </Form>
                  )}
                </Formik>
              </Stack>
            </Container>
          </Dialog>
        </Grid>
        {/* confirmation dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
          <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={DeleteAQLParameter} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default AQLParameter;
